import { __extends } from "tslib";
import { exposeGetters } from '@skbkontur/react-ui/lib/theming/ThemeHelpers';

var AddonsTheme8px =
/** @class */
function (_super) {
  __extends(AddonsTheme8px, _super);

  function AddonsTheme8px() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(AddonsTheme8px, "spinnerOldFontSizeSmall", {
    //#endregion
    //#region Spinner
    get: function get() {
      return this.spinnerFontSizeSmall;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AddonsTheme8px, "spinnerOldFontSizeMedium", {
    get: function get() {
      return this.spinnerFontSizeMedium;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AddonsTheme8px, "spinnerOldFontSizeLarge", {
    get: function get() {
      return this.spinnerFontSizeLarge;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AddonsTheme8px, "spinnerOldLineHeightSmall", {
    get: function get() {
      return this.spinnerLineHeightSmall;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AddonsTheme8px, "spinnerOldLineHeightMedium", {
    get: function get() {
      return this.spinnerLineHeightMedium;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AddonsTheme8px, "spinnerOldLineHeightLarge", {
    get: function get() {
      return this.spinnerLineHeightLarge;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AddonsTheme8px, "spinnerOldCaptionGapSmall", {
    get: function get() {
      return '6px';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AddonsTheme8px, "spinnerOldCaptionGapMedium", {
    get: function get() {
      return '-3px';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AddonsTheme8px, "spinnerOldCaptionGapLarge", {
    get: function get() {
      return '2px';
    },
    enumerable: true,
    configurable: true
  }); //#region Logotype

  AddonsTheme8px.logoDividerWidth = '0px';
  AddonsTheme8px.logoDividerHeight = '24px';
  AddonsTheme8px.logoDividerMarginX = '0';
  AddonsTheme8px.logoWidgetPaddingX = '0';
  AddonsTheme8px.logoButtonHeight = '32px';
  AddonsTheme8px.logoButtonWidth = '32px';
  AddonsTheme8px.logoButtonMarginLeft = '4px';
  AddonsTheme8px.logoButtonActionBorderRadius = '50%';
  AddonsTheme8px.logoButtonActionBackground = 'rgba(0, 0, 0, 0.05)'; //#endregion
  //#region TopBar

  AddonsTheme8px.tbShadow = '';
  AddonsTheme8px.tbHeight = '32px';
  AddonsTheme8px.tbPaddingX = '6px';
  AddonsTheme8px.tbPaddingY = '16px';
  AddonsTheme8px.tbMarginBottom = '0';
  AddonsTheme8px.tbItemPaddingX = '8px';
  AddonsTheme8px.tbItemMarginX = '0';
  AddonsTheme8px.tbDividerHeight = '24px';
  AddonsTheme8px.tbDividerMarginX = '8px';
  AddonsTheme8px.tbItemBorderRadius = '4px';
  AddonsTheme8px.tbItemActionBackground = 'rgba(0, 0, 0, 0.05)';
  AddonsTheme8px.tbOrganizationsCaptionLegacyPadding = '4px'; //#endregion
  //#region UserAvatar

  AddonsTheme8px.userAvatarSize = '32px';
  AddonsTheme8px.userAvatarBorderRadius = '100%';
  AddonsTheme8px.userAvatarBackground = 'transparent';
  AddonsTheme8px.userAvatarHoverBackground = '#222';
  AddonsTheme8px.userAvatarActiveBackground = '#222';
  AddonsTheme8px.userAvatarColor = '#222';
  AddonsTheme8px.userAvatarHoverColor = '#fff';
  AddonsTheme8px.userAvatarActiveColor = '#fff';
  return AddonsTheme8px;
}(
/** @class */
function () {
  function class_1() {}

  return class_1;
}());

export { AddonsTheme8px };
export var AddonsTheme8pxInternal = exposeGetters(AddonsTheme8px);